import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'time_and_billing_status',
})
export class StatusPipe implements PipeTransform {
  transform(type: number) {
    if (type == 0) {
      return 'WIP - Initially Entered'
    } else if (type == 1) {
      return 'WIP - Waiting For Approval'
    }
    else if (type == 2) {
      return 'WIP - Ready For Invoice'
    }
    else if (type == 3) {
      return 'Cleared - Invoiced'
    }
    else if (type == 4) {
      return 'Cleared - Write Off'
    }
    return type
  }
}
